<template>
  <LabelledInput
    :label="`${leafLevel.name} Label`"
    :helpful-tip="`Select the field to display as ${leafLevel.column} label in the mobile navigation`"
  >
    <b-radio-group
      v-model="projectLabelField"
      class="pb-3"
      :options="filteredFieldMap"
    />
    <b-card
      no-body
    >
      <b-list-group flush>
        <b-list-group-item
          v-for="project in projects"
          :key="project.path.toString()"
        >
          {{ project.data[projectLabelField] }}
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </LabelledInput>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import { FieldTypes } from '@/types'
import { APP_CONFIG_KEY } from '@/constants'

const components = {
  LabelledInput,
}

@Component({ components })
export default class SelectProjectLabelField extends Vue {
  get projectLabelField () {
    return this.$typedStore.primary.app.config.appConfig.projectLabelField
  }

  set projectLabelField (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [APP_CONFIG_KEY, 'projectLabelField'],
      value,
    })
  }

  get leafLevel () {
    return this.$typedStore.primary.app.levels.leafLevelField || {
      column: '',
      name: '',
    }
  }

  get fieldMap () {
    return this.$typedStore.primary.app.config.fieldMap
  }

  get filteredFieldMap () {
    return this.fieldMap.reduce((accumulator, currentField) => {
      if (currentField.type === FieldTypes.STRING || currentField.column === this.leafLevel.column) {
        accumulator.push({
          text: currentField.name,
          value: currentField.column,
        })
      }
      return accumulator
    }, [] as {value: string, text: string}[])
  }

  get projects () {
    return this.$typedStore.visualisationData.leafDataForRoot.slice(0, 1)
  }
}

</script>
